const x = {
  defaultProps: {
    PaperProps: {
      sx: { borderRadius: 4 },
      maxWidth: {
        xs: "375px",
        sm: "600px",
        md: "900px",
        lg: "1200px",
        xl: "1536px"
      }
    }
  }
};
export {
  x as dialog
};
//# sourceMappingURL=dialog.mjs.map
